import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const propTypes = {
  className: PropTypes.string,
  size: PropTypes.oneOf(['xs', 'sm', 'md', 'lg']),
  type: PropTypes.oneOf(['primary', 'secondary', 'white']),
};

const NativeActivityIndicator = ({ className, size = 'md', type }) => {
  const classes = classNames({
    'native-activity-indicator': true,
    [`size-${size}`]: true,
    [`type-${type}`]: !!type,
    [className]: !!className,
  });

  return (
    <div className={classes}>
      <div className="native-activity-indicator-wrap">
        <span />
        <span />
        <span />
        <span />
        <span />
        <span />
        <span />
        <span />
      </div>
    </div>
  );
};

NativeActivityIndicator.propTypes = propTypes;

export default NativeActivityIndicator;
